import type { EstimateType } from "@/enums/estimate-type";
import type { EmptyEventProperties } from "../types";

export interface ProjectArchiveInitiatedProps {
  estimate_id: string;
  estimate_type?: EstimateType;
}

export type ProjectArchiveCancelledProps = ProjectArchiveInitiatedProps;

export type ProjectArchivedProps = ProjectArchiveInitiatedProps;

export type EstimateCreationStartedProps = EmptyEventProperties;

export interface AdditionalUploadStartedProps {
  estimate_id: string;
  estimate_type?: EstimateType;
}

export interface EstimateSubmittedProps {
  estimate_type: EstimateType;
  file_count: number;
  has_photos: boolean;
  has_3d_scan: boolean;
}

export interface EstimateCancelInitiatedProps {
  estimate_type?: EstimateType;
  had_files: boolean;
}

export type EstimateCancelAbortedProps = EmptyEventProperties;

export interface EstimateDiscardedProps {
  estimate_type?: EstimateType;
  had_files: boolean;
}

export const ESTIMATE_EVENTS = {
  CREATION_STARTED: "estimate_creation_started",
  SUBMITTED: "estimate_submitted",
  CANCEL_INITIATED: "estimate_cancel_initiated",
  CANCEL_ABORTED: "estimate_cancel_aborted",
  DISCARDED: "estimate_discarded",
  ADDITIONAL_UPLOAD_STARTED: "additional_upload_started",
  PROJECT_ARCHIVE_INITIATED: "project_archive_initiated",
  PROJECT_ARCHIVE_CANCELLED: "project_archive_cancelled",
  PROJECT_ARCHIVED: "project_archived",
} as const;

export interface EstimateEventPropertiesMap {
  [ESTIMATE_EVENTS.CREATION_STARTED]: EstimateCreationStartedProps;
  [ESTIMATE_EVENTS.SUBMITTED]: EstimateSubmittedProps;
  [ESTIMATE_EVENTS.CANCEL_INITIATED]: EstimateCancelInitiatedProps;
  [ESTIMATE_EVENTS.CANCEL_ABORTED]: EstimateCancelAbortedProps;
  [ESTIMATE_EVENTS.DISCARDED]: EstimateDiscardedProps;
  [ESTIMATE_EVENTS.ADDITIONAL_UPLOAD_STARTED]: AdditionalUploadStartedProps;
  [ESTIMATE_EVENTS.PROJECT_ARCHIVE_INITIATED]: ProjectArchiveInitiatedProps;
  [ESTIMATE_EVENTS.PROJECT_ARCHIVE_CANCELLED]: ProjectArchiveCancelledProps;
  [ESTIMATE_EVENTS.PROJECT_ARCHIVED]: ProjectArchivedProps;
}
